// dependencies
import React from "react";

import { toast } from "@performyard/py-components";

import useNavigate from "../../../../../../../hooks/useNavigate";

// services
import { createDynamicCohort } from "../../../../../../../api/services";

import { FormState } from "../..";
// components
import DynamicEmployeesQueryBuilder from "../../../../Components/DynamicEmployeesQueryBuilder";
import { DynamicCohortQuery } from "../../../../Components/DynamicEmployeesQueryBuilder/DynamicEmployeesUtils";

declare interface DynamicEmployeesCreateProps {
	goBack: () => void;
	state: FormState;
}

interface CustomError extends Error {
	data: {
		errors: string[];
	};
}

const DynamicEmployeesCreate = ({ goBack, state }: DynamicEmployeesCreateProps) => {
	const navigate = useNavigate();

	return (
		<DynamicEmployeesQueryBuilder
			goBack={goBack}
			onSave={async (newDynamicCohortQuery: DynamicCohortQuery) => {
				try {
					await createDynamicCohort(state.name, state.description, state.color, newDynamicCohortQuery);
					toast.success("Successfully saved new dynamic cohort");

					navigate("/administration/engagement/cohorts");
				} catch (error) {
					const errorMessage = (error as CustomError)?.data?.errors[0] || "Failed to save new dynamic cohort";
					toast.error(errorMessage);
				}
			}}
			existingDynamicEmployeesQuery={state?.query as DynamicCohortQuery}
		/>
	);
};

export default DynamicEmployeesCreate;
